import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout route for the Xero sub-tree (panel at `/settings/xero`, OAuth
 * callback relay at `/settings/xero/callback`) — mirrors
 * silo-counts/counts.tsx's identical layout-plus-children pattern. No chrome
 * of its own; the parent `settings.tsx` layout already renders the tab strip.
 * Needed because `xero.callback.tsx` (BUILD_SPEC.md §12's OAuth redirect
 * target) is necessarily a CHILD of this file once both exist side by side
 * (TanStack Router's flat file routing) — without a real `<Outlet/>` here,
 * that child route would never render. Plan.md G26. */
export const Route = createFileRoute('/_authenticated/settings/xero')({
  component: () => <Outlet />,
});
